<template>
  <v-row justify="center">
    <v-col cols="12" style="max-width:680px">
      <v-sheet class="pt-12 text-left">
        <h1 class="display-2 font-weight-bold d-inline-block mr-4"
          >Privacy Policy</h1
        >
        <v-row wrap>
          <v-col class="pb-7">
            <VueMarkdown :source="policy" class="markdown-body" />
          </v-col>
        </v-row>
      </v-sheet>
    </v-col>
  </v-row>
</template>

<script>
import VueMarkdown from 'vue-markdown'
import policy from '@/constants/PrivacyPolicy.md'

export default {
  name: 'PrivacyPolicyView',
  components: { VueMarkdown },
  data() {
    return {
      policy,
    }
  },
}
</script>

<style lang="scss">
.markdown-body {
  font-family: proxima-nova, sans-serif;
  font-weight: 400;
  strong {
    font-weight: bold;
  }
}
</style>
